// AppShell — 响应式三 Tab 布局
// 复刻 LocalSend home_page.dart:104-181
//   桌面 (>=768px): 左侧 NavigationRail + 顶部"快船"32px 粗体
//   移动 (<768px):  底部 NavigationBar

import type { ReactNode } from 'react';
import { APP_NAME } from '@kuaichuan/shared';
import { Logo } from '../common/Logo';

export type HomeTab = 'receive' | 'send' | 'chat' | 'settings';

interface TabConfig {
  key: HomeTab;
  label: string;
  icon: string;
}

const TABS: TabConfig[] = [
  { key: 'receive', label: '接收', icon: '🌊' },
  { key: 'send', label: '发送', icon: '🚀' },
  { key: 'chat', label: '聊天', icon: '💬' },
  { key: 'settings', label: '设置', icon: '⚙️' },
];

interface AppShellProps {
  currentTab: HomeTab;
  onTabChange: (tab: HomeTab) => void;
  children: ReactNode;
}

export function AppShell({ currentTab, onTabChange, children }: AppShellProps) {
  return (
    <div className="min-h-full flex">
      {/* 桌面左侧 NavigationRail */}
      <aside className="hidden md:flex md:flex-col md:w-56 lg:w-64 border-r border-border bg-surface/60 backdrop-blur-sm">
        <div className="px-6 py-8 flex items-center gap-2">
          <Logo size="md" />
          <span className="text-2xl font-bold text-ink">{APP_NAME}</span>
        </div>
        <nav className="flex-1 flex flex-col gap-1 px-3">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => onTabChange(tab.key)}
              className={`
                flex items-center gap-3 px-4 py-3 rounded-md text-left transition-all
                ${currentTab === tab.key ? 'bg-primary-50 text-primary font-medium' : 'text-muted hover:bg-bg hover:text-ink'}
              `}
            >
              <span className="text-2xl">{tab.icon}</span>
              <span className="text-base">{tab.label}</span>
            </button>
          ))}
        </nav>
        <div className="p-4 text-xs text-muted text-center">
          <p>跨设备点对点传输</p>
          <p className="mt-1">文件不经服务器</p>
        </div>
      </aside>

      {/* 主内容区 */}
      <main className="flex-1 min-w-0 flex flex-col">
        {/* 移动顶部 header */}
        <header className="md:hidden flex items-center justify-center px-4 py-3 border-b border-border bg-surface/60 backdrop-blur-sm">
          <Logo size="sm" withText />
        </header>
        <div className="flex-1 overflow-y-auto">{children}</div>
      </main>

      {/* 移动底部 NavigationBar */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 flex border-t border-border bg-surface/95 backdrop-blur-md z-30"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => onTabChange(tab.key)}
            className={`
              flex-1 flex flex-col items-center gap-0.5 py-2 transition-all
              ${currentTab === tab.key ? 'text-primary' : 'text-muted'}
            `}
          >
            <span className="text-2xl">{tab.icon}</span>
            <span className="text-xs">{tab.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
